/**
 * E-consent visibility status for chrome (Header / MobileBottomNav).
 *
 * Ticket pending (applied per Rock, 2026-07-23): while a logged-in borrower
 * has NOT accepted e-consent, the app renders NO navigation — the borrower
 * can only interact with the /e-consent page (EConsentGate blocks every
 * other route as the backstop).
 *
 * Consent state is the in-memory session store (API-backed, no browser
 * persistence). While the answer is still 'unknown' (API in flight) the nav
 * stays hidden — fail-closed visuals; consented users see at most a brief
 * chrome-less frame on a hard refresh.
 */

import { useSyncExternalStore } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getConsentStatus, subscribeConsent } from '@/lib/consent';

export function useEConsentGateStatus(): { consented: boolean } {
  const { user } = useAuth();
  const userId = (user?.email ?? user?.id ?? '').toString() || undefined;
  const status = useSyncExternalStore(
    subscribeConsent,
    () => getConsentStatus(userId),
    () => getConsentStatus(userId),
  );

  if (!user) return { consented: true };
  // No mock shortcut (per Rock 2026-07-23): the consent API answers in every
  // auth mode — MSW serves the same endpoints for local mock sessions.
  return { consented: status === 'consented' };
}
